import React from 'react';
import { BrowserRouter as Router, RouterProvider } from 'react-router-dom';
import { router } from './router';
import { FirebaseProvider } from './contexts/FirebaseContext';
import './styles/index.css';

function App() {
  return (
    <FirebaseProvider>
      <div className="min-h-screen bg-gray-900">
        <RouterProvider router={router} />
      </div>
    </FirebaseProvider>
  );
}

export default App;